import React from "react";

import Step from "../../../../../../atoms/Wizard/Step";
import MainDropdown from "../../../../../../atoms/Forms/MainDropdown";

import styles from  "./Step1.module.scss";
import i18n from "i18n";

export const RequestOrderStep1 = ({ options, option, handleChange}) => {

    const stepContent = (
        <div className={styles["request-order-step-one-content"]}>
          <div className={styles["request-order-step-one-field"]} data-automation-id="input-name">
            <MainDropdown
              label={i18n.t("select")}
              placeholder = {i18n.t("select")}
              required={true}
              id={"dest"}
              name="dest"
              value={option}
              selectedOption={option}
              options={options}
              handleChange={handleChange}
              handleSelection={handleChange}
            />
          </div>

        </div>
      );
    return (
        <div className={styles["request-order-step-one-container"]}>
          <Step title={i18n.t("select.origin.order")} content={stepContent}></Step>
        </div>
      );
}

export default RequestOrderStep1